import { render } from "./LoaderImage.vue?vue&type=template&id=8d471bdc&scoped=true"
import script from "./LoaderImage.vue?vue&type=script&lang=js"
export * from "./LoaderImage.vue?vue&type=script&lang=js"

import "./LoaderImage.vue?vue&type=style&index=0&id=8d471bdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d471bdc"]])

export default __exports__